import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { MeetCenia } from './components/MeetCenia';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Properties } from './components/Properties';
import { Neighborhoods } from './components/Neighborhoods';
import { Testimonials } from './components/Testimonials';
import { WorkWithCenia } from './components/WorkWithCenia';
import { Contact } from './components/Contact';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingButtons } from './components/FloatingButtons';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="28tw3qn4zwc1c">
      <div className="min-h-screen bg-white text-[#1a1a1a] font-sans overflow-x-hidden" data-id="element-1" data-mp="28t4lee0esat0">
        <Navbar data-id="element-2" data-mp="23u9ueosaffxt" />

        <main data-id="element-3" data-mp="23utby4e102bb">
          <Hero data-id="element-4" data-mp="23t8heerpojdg" />
          <Marquee data-id="element-5" data-mp="23ti5fwt74ggi" />
          <MeetCenia data-id="element-6" data-mp="3ikh8ubu2yx01" />
          <Stats data-id="element-7" data-mp="3iiwfgpji5k3r" />
          <Services data-id="element-8" data-mp="3ijfvg0pldyf5" />
          <Properties data-id="element-9" data-mp="3ihuyk4ft23e4" />
          <Neighborhoods data-id="element-10" data-mp="3mlavz2zp87rv" />
          <Testimonials data-id="element-11" data-mp="3mkhlbqxmcy4g" />
          <WorkWithCenia data-id="element-12" data-mp="3mjzpuwis6nxl" />
          <FAQ data-id="element-13" data-mp="3mj6j3vjtnyfg" />
          <Contact data-id="element-14" data-mp="3rcj7q5oi4587" />
        </main>

        <Footer data-id="element-15" data-mp="3rdkhm6ts6loc" />
        <FloatingButtons data-id="element-16" data-mp="3rd1bdndhtlq5" />
      </div>
    </LanguageProvider>;
}